export default {
    nl: {
        intro: {
            subtitle: 'PHP',
            title: 'Vloeiend PHP spreken.',
            contact: 'Neem contact op',
            image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/php/hero.jpg',
        },
        type: 'PHP',
        title: 'PHP voor webontwikkeling: flexibel, snel en schaalbaar',
        description:
            'Ontdek PHP voor webontwikkeling. Met platformonafhankelijkheid, krachtige frameworks en actieve community versterkt PHP uw projecten.',
        content: [
            {
                type: 'text',
                title: 'PHP',
                content:
                    'PHP (Hypertext Preprocessor) is een veel gebruikte programmeertaal en vormt de kern van vele dynamische webapplicaties en websites die we dagelijks tegenkomen. In de wereld van webontwikkeling is PHP een gouden standaard geworden, mede dankzij de ongekende steun van een wereldwijde, actieve community van ontwikkelaars.',
            },
            {
                type: 'text',
                title: 'Meer dan alleen codes kraken',
                content:
                    'Een van de meest opvallende eigenschappen van PHP is de platformonafhankelijkheid. Het maakt niet uit of je werkt met Windows, Linux of macOS, want PHP werkt met alle besturingssystemen. Het platform is voorzien van uitgebreide ingebouwde functies en de ondersteuning voor database systemen zoals MySQL. Dit maakt PHP de voorkeurstaal in webapplicaties. Het naadloos beheren en integreren van gegevens is hierdoor erg eenvoudig, vooral wanneer je dit koppelt aan een klantportaal of een geavanceerde API.',
            },
            {
                type: 'quote',
                content:
                    'PHP kan een hoop tegelijk aan. Hierdoor draaien webapplicaties efficiënter.',
            },
            {
                type: 'text',
                title: 'Waarom een pentest essentieel is',
                content:
                    'PHP wordt uitgebreid met krachtige frameworks zoals Laravel. Deze frameworks transformeren de manier waarop we complexe webapplicaties benaderen, met een heldere structuur en begrijpelijke aanpak. Hierdoor wordt het ontwikkelproces efficiënter en worden de onderhoudskosten verlaagd. Samen met onze teams van front-end en back-end development, zetten we deze tools in om hoogwaardige digitale producten te creëren.',
            },
            {
                type: 'list',
                title: 'De voordelen van PHP op een rij',
                items: [
                    'Voor iedereen, door iedereen: PHP is open-source. Dat betekent dat het niet alleen gratis is, maar dat gepassioneerde ontwikkelaars over de hele wereld er dagelijks aan bijdragen.',
                    'Een helpende hand: dankzij een grote community van ontwikkelaars is er een zee aan bronnen, handleidingen en hulp beschikbaar. Loop je ergens tegenaan? De kans is groot dat iemand al een oplossing heeft gevonden.',
                    'Snelheid voorop: een groot aantal webverzoeken? PHP kan een hoop tegelijk aan. Hierdoor draaien webapplicaties efficiënter.',
                    'Database ondersteuning: of je nu met MySQL, PostgreSQL of SQLite werkt, PHP kan ermee overweg. Het verwerken en beheren van je gegevens wordt zo voor iedere ontwikkelaar toegankelijk.',
                    'Code hergebruiken en frameworks: PHP juicht hergebruik van code toe. Met frameworks zoals Laravel, Symfony of CodeIgniter werk je snel en gestroomlijnd.',
                ],
            },
            {
                type: 'case',
                case: 'recirculo',
            },
        ],
        related_services: ['client-portal', 'back-end-development', 'intranet'],
        contact: {
            title: '',
            employee: 'tobias',
        },
    },
    en: {},
};
